var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F79009",
    strokeWidth: 1.5,
    d: "M11.833 8.5a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.666 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F79009",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.497 2.5h.006m-.006 12h.006M12.74 4.257h.006m-8.489 8.486h.006m-.006-8.485h.006m8.477 8.485h.006M14.494 8.5h.006m-12 0h.006"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunL);
export default __webpack_public_path__ + "static/media/sun_l.33731f404601009c115bb3263c691fcc.svg";
export { ForwardRef as ReactComponent };